import { useState } from 'react';
import { useRequest } from 'ahooks';
import { getPolicyJiedu } from '../axios/api';

function useGetPolicyJiedu() {
  const [jieduCache, setJieduCache] = useState({});

  const { loading, data, runAsync: getPolicyJieduAction } = useRequest(
    async (params) => {
      try {
        const resp = await getPolicyJiedu(params);
        return resp?.data ?? undefined;
      } catch (error) {
        return undefined;
      }
    },
    {
      debounceWait: 1,
      manual: true,
    }
  );

  const getJieduWithCache = async (policyTitle, policyTime) => {
    // 如果缓存中已有结果，直接返回
    if (jieduCache[policyTitle] !== undefined) {
      return jieduCache[policyTitle];
    }

    // 调用接口，只在有 policyTime 时才添加该参数
    const params = { 
      policy_title: policyTitle
    };
    if (policyTime) {
      params.policy_time = policyTime;
    }
    const result = await getPolicyJieduAction(params);
    
    // 缓存结果
    setJieduCache(prev => ({
      ...prev,
      [policyTitle]: result
    }));

    return result;
  };

  return {
    loading,
    data,
    getPolicyJieduAction,
    getJieduWithCache,
    jieduCache
  };
}

export default useGetPolicyJiedu; 